// Entry point for the React app
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

const root = createRoot(document.getElementById('root'));
root.render(<App />);

// To run frontend:
// 1. Open VS Code terminal in the `frontend` folder
// 2. Run `npm install` to install dependencies
// 3. Run `npm start` to start the dev server (http://localhost:3000)
